module.exports = __webpack_public_path__ + "static/complex_scroll_4-c7382d7639cce2f0404d0be34a3cde7b.png";